import { render, staticRenderFns } from "./CameraDetail.vue?vue&type=template&id=6465848f&"
import script from "./CameraDetail.vue?vue&type=script&lang=js&"
export * from "./CameraDetail.vue?vue&type=script&lang=js&"
import style0 from "./CameraDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports